import { useCallback, useState } from 'react'
type UseFuncWithConfirmationReturnType = {
  closeModal: () => void
  onConfirm: () => void
  onCancel: () => void
  attemptedToCall: boolean
}

const useFuncWithConfirmation = (
  func: (...args: Array<any>) => any,
): UseFuncWithConfirmationReturnType => {
  const [attemptedToCall, setAttemptedToCall] = useState(false)
  const closeModal = useCallback(() => {
    setAttemptedToCall(true)
  }, [])
  const onConfirm = useCallback(() => {
    func()
    setAttemptedToCall(false)
  }, [func])
  const onCancel = useCallback(() => {
    setAttemptedToCall(false)
  }, [])
  return {
    closeModal,
    onConfirm,
    onCancel,
    attemptedToCall,
  }
}

export default useFuncWithConfirmation
